/**
 * @name store/index.js
 * @module app
 *
 * @description
 * The typescript store.
 *
 * @project spotgig4web
 * @author Ryunosuke Oguri on 2017/08/08
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import auth from './modules/auth/'
import config from './modules/config/'

import phoneNumberAuthorization from './modules/phone_number_authorizations'
import signup from './modules/signup'
import postals from './modules/postals'

Vue.use(Vuex)

const debug = process.env.VUE_APP_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    auth,
    config,
    phoneNumberAuthorization,
    signup,
    postals
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
